import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { ApplicationModule } from './application/application.module';
import { SharedModule } from './shared/shared.module';
import { ApplicationRoutingModule } from './application/application-routing.module';

import { AppComponent } from './app.component';
import { SharedRoutingModule } from './shared/shared-routing.module';
import { AuthInterceptor } from './shared/services/auth.interceptor';

import { environment } from 'src/environments/environment.prod';
import { ModalComponent } from './shared/modal/modal.component';
import { ModalService } from './shared/services/modal.service';
import { CanDeactivateGuard } from './shared/services/can-deactivate.guard.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccessibilityService } from './shared/services/accessibility.service';
import { MatSortHeaderIntl } from '@angular/material';
import { CustomMatSortHeaderIntl } from './shared/services/custom-mat-sort-header-intl';

import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_BASE_URL } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { VersionCheckService } from './shared/services/version-check.service';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { SpinnerService } from './shared/services/spinner.service';
import { RectComponent } from './shared/skeleton-rect/skeleton-rect.component';
import { retireUnwantedLocalStorageKeys } from './shared/services/retire-unwanted-local-storage-keys';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    
    AppComponent,
    ModalComponent,    
  ],
  entryComponents: [
    RectComponent
  ],
  imports: [
    BrowserModule,
    SharedRoutingModule,
    ApplicationRoutingModule,
    AppRoutingModule,
    SharedModule,
    ApplicationModule,
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp: [
        'scanstatus'
      ]
    }),
    
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      name: 'online app',
      maxAge: 25,
      logOnly: environment.production
    }),
    BrowserAnimationsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    /* We are handling showing or hiding spinner for ajax calls in NgxUiLoaderHttpModule */
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AjaxBusyIdentifierInterceptor,
    //   multi: true
    // },
    {
      provide: APP_INITIALIZER,
      useValue: retireUnwantedLocalStorageKeys,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }, 
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6Ld2gM8cAAAAAL7qr1pco_xydqg_gdd4GtVla7MC',
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: "https://recaptcha.net/recaptcha/api.js",
    },
    SpinnerService,
    ModalService, 
    CanDeactivateGuard,
    { provide: MatSortHeaderIntl, useClass: CustomMatSortHeaderIntl },
    AccessibilityService,
    VersionCheckService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
